<template lang="pug">
header.i_ptb_10
  .container.custom_container_md
    .header_container.flex_h
      .left.flex_v
        .title_content.flex_h
          h1 {{ title }}
          img.d-md-none(v-if="image != undefined",:src="image")
          iframe.d-md-none(width="100%", height="100%", v-if="youtube!= undefined",:src="youtube")
        p.i_content.i_mt_3 {{ subTitle }}
        p.i_content.i_mt_3.alert1(v-if="Alert1 != undefined")  {{ Alert1 }}
          i(style="float:left;width:30px; height:30px")
            img(:src="icon1",style="width:100%; height:100%; vertical-align: middle;")
        p.i_content.i_mt_3.alert2(v-if="Alert1 != undefined") 
          a(:href="DownloadList_URL",target="_blank")  {{ Alert2 }}
            i(style="float:left;width:30px; height:30px")
              img(:src="icon1",style="width:100%; height:100%; vertical-align: middle;")
        .btn_wrapper
          a.btn_round(
            v-if="buttonName && 'toTermsFile' != buttonURL",
            :href="buttonURL",
            target="_blank"
          ) {{ buttonName }}
          router-link.btn_round(
            v-if="buttonName && 'toTermsFile' == buttonURL",
            tag="a",
            :to="{ name: 'CustomerServiceDocumentDownloadTerms' }"
          ) {{ buttonName }}
      .right
        img.d-none.d-md-block(v-if="image != undefined",:src="image")
        iframe.d-none.d-md-block(width="100%", height="100%", v-if="youtube != undefined",:src="youtube")
</template>

<script>
export default {
  name: "Header",
  props: {
    title: String,
    subTitle: String,
    Alert1: String,
    Alert2: String,
    DownloadList_URL: String,
    icon1: String,
    icon2: String,
    image: String,
    youtube: String,
    buttonName: String,
    buttonURL: String,
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/customer_service/header";
</style>
